// extracted by mini-css-extract-plugin
export default {"newCreditLimit":"ApplyFlexiLoanFormView_newCreditLimit","backBtn":"ApplyFlexiLoanFormView_backBtn"};